import React from 'react'
import PropTypes from 'prop-types'

import { Text } from 'Components/UI'
import { Flex } from 'Components/UI/_Legacy'

import {
  Container,
  Description,
  HiderBottom,
  HiderTop,
  Wrapper,
} from './styles'

import { PathVertical, Point } from '../paths'

function DataBlock({ step, index, odd }) {
  return (
    <Container>
      <Wrapper>
        <Point />

        <Flex
          display={['none', 'none', 'flex']}
          justifyContent="center"
          width={3}
        />

        {index === 0 ? <HiderTop /> : null}

        {index === 3 ? <HiderBottom /> : null}

        <Text as="h3" bold fontSize={[18, 18, 20]} ml={[5, 5, 7, 9]}>
          {step.title}
        </Text>
      </Wrapper>

      <Description ml={[5, 5, 7, 9]} mt={3}>
        {step.description}
      </Description>

      <PathVertical display={['none', 'none', 'flex']} shift={!odd} />
    </Container>
  )
}

DataBlock.propTypes = {
  index: PropTypes.number.isRequired,
  odd: PropTypes.bool.isRequired,
  step: PropTypes.object.isRequired,
}

export default DataBlock
